import { c as _c } from "react/compiler-runtime";
import { FormInput, PrimaryButton } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import StepConfigurationTabLayout from 'modules/funnels/funnel/components/step-configuration-tab/step-configuration-tab-layout';
import { useEmbeddedFormFields } from 'modules/funnels/funnel/hooks/use-embedded-form-fields';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { useRemoteFormSettings } from 'modules/funnels/funnel/hooks/use-remote-form-settings';
import { useResetFunnelStepPageTemplate } from 'modules/funnels/funnel/hooks/use-reset-funnel-step-page-template';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { RemoteFormEditInterface, RemoteFormFieldErrorResponseContentInterface, RemoteFormFieldErrorsInterface, RemoteFormInterface } from 'modules/funnels/funnel/types/remote-form-interface';
import { getEmbeddedFormHtmlCode, getScriptTagHtmlCode } from 'modules/funnels/funnel/utils/remote-form-utils';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React, { useEffect, useState } from 'react';
import LinkShareModal from 'shared/components/link-share-modal';
import { Loader } from 'shared/components/loader';
import { FunnelStepTypeEnum } from 'shared/enums/funnel-step-type-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getPageEditorUrl } from 'shared/utils/get-page-editor-url';
import { getStateStatusIcon } from 'shared/utils/get-status-icon';
import { useFunnelStepsList } from '../../../hooks/use-funnel-steps-list';
import { useBaseConfigurationTabFieldState, useUpdateBaseConfigurationTab } from '../../../hooks/use-update-base-configuration-tab';
import EmbeddedFormIcon from '../../../icons/embedded-form-icon';
import CreateRemotePopupLinkModal from './create-remote-popup-link-modal';
import { LinkIcon } from '@systemeio/ui/icons';
import { getRemotePagePreviewUrl } from 'modules/funnels/funnel/utils/page-utils';
const defaultValues: RemoteFormEditInterface = {
  name: ''
};
const defaultErrors: RemoteFormFieldErrorsInterface = {
  name: ''
};
interface RemoteFormConfigurationTabProps {
  funnelStep: FunnelStepInterface;
  funnelId: FunnelId;
}
function RemoteFormConfigurationTab(t0) {
  const $ = _c(92);
  const {
    funnelStep,
    funnelId
  } = t0;
  const {
    remoteFormSettings,
    mutateRemoteFormSettings
  } = useRemoteFormSettings(funnelStep.id);
  const {
    t
  } = useLocoTranslation();
  const {
    funnel
  } = useFunnel(funnelId);
  let t1;
  if ($[0] !== funnelId || $[1] !== funnelStep.id) {
    t1 = {
      funnelId,
      funnelStepId: funnelStep.id
    };
    $[0] = funnelId;
    $[1] = funnelStep.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    resetFunction
  } = useResetFunnelStepPageTemplate(t1);
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const [tempState, setTempState] = useState(defaultValues);
  const [errors, setErrors] = useState(defaultErrors);
  const [openedScriptModal, setOpenedScriptModal] = useState(false);
  const [openedEmbeddedModal, setOpenedEmbeddedModal] = useState(false);
  const [openedLinkModal, setOpenedLinkModal] = useState(false);
  const [shouldFetchEmbeddedForm, setShouldFetchEmbeddedForm] = useState(false);
  const {
    embeddedFormFields
  } = useEmbeddedFormFields(shouldFetchEmbeddedForm, funnelStep.page?.id);
  const isScriptModalVisible = !!(funnel && funnel.domain.domainName && remoteFormSettings && remoteFormSettings.page.hash);
  const t2 = `${FUNNELS_API}/step-remote-form/${funnelStep.id}`;
  let t3;
  if ($[3] !== funnelId || $[4] !== funnelStep.id || $[5] !== t2) {
    t3 = {
      funnelStepId: funnelStep.id,
      funnelId,
      updateUrl: t2
    };
    $[3] = funnelId;
    $[4] = funnelStep.id;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    updateFetcher,
    isFetching
  } = useUpdateBaseConfigurationTab(t3);
  const isPopup = funnelStep.type === FunnelStepTypeEnum.Popup;
  const [savedState, setSavedState] = useState(defaultValues);
  let t4;
  if ($[7] !== savedState || $[8] !== tempState) {
    t4 = {
      savedState,
      currentState: tempState
    };
    $[7] = savedState;
    $[8] = tempState;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    isNameChanged,
    successState,
    setSuccessState
  } = useBaseConfigurationTabFieldState(t4);
  let t5;
  if ($[10] !== funnelStep.id || $[11] !== isNameChanged || $[12] !== mutateFunnelStepsList || $[13] !== mutateRemoteFormSettings || $[14] !== setSuccessState || $[15] !== tempState || $[16] !== updateFetcher) {
    t5 = async () => {
      ;
      try {
        setErrors(defaultErrors);
        await updateFetcher(tempState, async () => {
          setSuccessState(prev_0 => ({
            ...prev_0,
            name: isNameChanged
          }));
          setSavedState(prev_1 => ({
            ...prev_1,
            name: isNameChanged
          }));
          await mutateRemoteFormSettings(data => {
            if (data) {
              return {
                ...data,
                name: tempState.name
              };
            }
          }, false);
          await mutateFunnelStepsList(data_0 => {
            if (data_0) {
              return data_0.map(dataFunnelStep => {
                if (dataFunnelStep.id === funnelStep.id) {
                  return {
                    ...dataFunnelStep,
                    name: tempState.name
                  };
                }
                return dataFunnelStep;
              });
            }
          }, false);
        });
      } catch (t6) {
        const e = t6;
        if (e instanceof BadRequest) {
          if (e.errors.fields) {
            const errors_0 = e.errors.fields as unknown as RemoteFormFieldErrorResponseContentInterface;
            setErrors(prev => ({
              ...prev,
              name: errors_0.name?.join("")
            }));
          }
        }
      }
    };
    $[10] = funnelStep.id;
    $[11] = isNameChanged;
    $[12] = mutateFunnelStepsList;
    $[13] = mutateRemoteFormSettings;
    $[14] = setSuccessState;
    $[15] = tempState;
    $[16] = updateFetcher;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const handleSave = t5;
  let t6;
  let t7;
  if ($[18] !== remoteFormSettings) {
    t6 = () => {
      if (remoteFormSettings) {
        setTempState(prev_2 => ({
          ...prev_2,
          name: remoteFormSettings.name
        }));
        setSavedState(prev_3 => ({
          ...prev_3,
          name: remoteFormSettings.name
        }));
      }
    };
    t7 = [remoteFormSettings];
    $[18] = remoteFormSettings;
    $[19] = t6;
    $[20] = t7;
  } else {
    t6 = $[19];
    t7 = $[20];
  }
  useEffect(t6, t7);
  if (!remoteFormSettings || !funnel || !funnelStep.page) {
    let t8;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <div className="flex h-full items-center justify-center py-12"><Loader className="scale-150" /></div>;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    return t8;
  }
  let t8;
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setOpenedEmbeddedModal(true);
    t9 = <EmbeddedFormIcon className="fill-background-secondary h-[18px] w-[18px]" />;
    $[22] = t8;
    $[23] = t9;
  } else {
    t8 = $[22];
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t) {
    t10 = t("dashboard.funnel.configuration.remote.embedded_form");
    $[24] = t;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10) {
    t11 = <PrimaryButton className="!justify-start" onClick={t8}>{t9}<span className="font-inter text-start font-normal">{t10}</span></PrimaryButton>;
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== funnelStep.page.id) {
    t12 = getRemotePagePreviewUrl(funnelStep.page.id);
    $[28] = funnelStep.page.id;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== funnelStep.page.id) {
    t13 = getPageEditorUrl(funnelStep.page.id);
    $[30] = funnelStep.page.id;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t) {
    t14 = t("global.name");
    $[32] = t;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  const t15 = tempState.name;
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = e_0 => setTempState(prev_4 => ({
      ...prev_4,
      name: e_0.target.value
    }));
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== handleSave || $[36] !== isNameChanged) {
    t17 = () => isNameChanged && handleSave();
    $[35] = handleSave;
    $[36] = isNameChanged;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  const t18 = successState.name;
  const t19 = isFetching && isNameChanged;
  let t20;
  if ($[38] !== successState.name || $[39] !== t19) {
    t20 = getStateStatusIcon(t19, successState.name);
    $[38] = successState.name;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== errors.name || $[42] !== successState.name || $[43] !== t14 || $[44] !== t17 || $[45] !== t20 || $[46] !== tempState.name) {
    t21 = <FormInput required={true} label={t14} labelClassName="lg:text-[15px] font-medium text-sm text-text-primary" value={t15} onChange={t16} onBlur={t17} maxLength={256} success={t18} statusIcon={t20} error={errors.name} />;
    $[41] = errors.name;
    $[42] = successState.name;
    $[43] = t14;
    $[44] = t17;
    $[45] = t20;
    $[46] = tempState.name;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = () => setOpenedScriptModal(true);
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  const t23 = !isScriptModalVisible;
  let t24;
  if ($[49] !== t) {
    t24 = t("dashboard.funnel.configuration.remote.script");
    $[49] = t;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t24) {
    t25 = <span>{"</>"} {t24}</span>;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t23 || $[54] !== t25) {
    t26 = <PrimaryButton className="max-w-fit" onClick={t22} disabled={t23}>{t25}</PrimaryButton>;
    $[53] = t23;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== isPopup || $[57] !== t) {
    t27 = isPopup && <PrimaryButton className="max-w-fit" onClick={() => setOpenedLinkModal(true)}><LinkIcon className="fill-background-secondary h-[18px]  w-[18px]" /><span>{t("dashboard.funnel.configuration.remote.create_link")}</span></PrimaryButton>;
    $[56] = isPopup;
    $[57] = t;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== t26 || $[60] !== t27) {
    t28 = <div className="flex gap-5">{t26}{t27}</div>;
    $[59] = t26;
    $[60] = t27;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== funnel || $[63] !== funnelStep.id || $[64] !== isScriptModalVisible || $[65] !== openedScriptModal || $[66] !== remoteFormSettings || $[67] !== t) {
    t29 = isScriptModalVisible && <LinkShareModal link={getScriptTagHtmlCode(funnel.domain.domainName, remoteFormSettings.page.hash, funnelStep.id)} label="" title={t("dashboard.funnel.configuration.remote.script_tag")} opened={openedScriptModal} onClose={() => setOpenedScriptModal(false)} />;
    $[62] = funnel;
    $[63] = funnelStep.id;
    $[64] = isScriptModalVisible;
    $[65] = openedScriptModal;
    $[66] = remoteFormSettings;
    $[67] = t;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  let t30;
  if ($[69] !== embeddedFormFields || $[70] !== funnelStep.page || $[71] !== openedEmbeddedModal || $[72] !== t) {
    t30 = funnelStep.page !== null && <LinkShareModal link={embeddedFormFields ? getEmbeddedFormHtmlCode(embeddedFormFields, funnelStep.page.id) : ""} isLoading={!embeddedFormFields} label="" title={t("dashboard.funnel.configuration.remote.script_tag")} opened={openedEmbeddedModal} onClose={() => setOpenedEmbeddedModal(false)} onOpen={() => setShouldFetchEmbeddedForm(true)} showInTextArea={true} />;
    $[69] = embeddedFormFields;
    $[70] = funnelStep.page;
    $[71] = openedEmbeddedModal;
    $[72] = t;
    $[73] = t30;
  } else {
    t30 = $[73];
  }
  let t31;
  if ($[74] !== funnel || $[75] !== funnelStep.id || $[76] !== isPopup || $[77] !== openedLinkModal || $[78] !== remoteFormSettings) {
    t31 = isPopup && <CreateRemotePopupLinkModal opened={openedLinkModal} onClose={() => setOpenedLinkModal(false)} domainName={funnel.domain.domainName} pageHash={remoteFormSettings.page.hash} funnelStepId={funnelStep.id} />;
    $[74] = funnel;
    $[75] = funnelStep.id;
    $[76] = isPopup;
    $[77] = openedLinkModal;
    $[78] = remoteFormSettings;
    $[79] = t31;
  } else {
    t31 = $[79];
  }
  let t32;
  if ($[80] !== t21 || $[81] !== t28 || $[82] !== t29 || $[83] !== t30 || $[84] !== t31) {
    t32 = <div className="flex flex-col gap-5">{t21}{t28}{t29}{t30}{t31}</div>;
    $[80] = t21;
    $[81] = t28;
    $[82] = t29;
    $[83] = t30;
    $[84] = t31;
    $[85] = t32;
  } else {
    t32 = $[85];
  }
  let t33;
  if ($[86] !== resetFunction || $[87] !== t11 || $[88] !== t12 || $[89] !== t13 || $[90] !== t32) {
    t33 = <StepConfigurationTabLayout additionalAction={t11} viewLinkUrl={t12} editLinkUrl={t13} onChangeTemplate={resetFunction}>{t32}</StepConfigurationTabLayout>;
    $[86] = resetFunction;
    $[87] = t11;
    $[88] = t12;
    $[89] = t13;
    $[90] = t32;
    $[91] = t33;
  } else {
    t33 = $[91];
  }
  return t33;
}
export default RemoteFormConfigurationTab;